<template>
  <v-alert
    v-if="visible"
    type="info"
    variant="tonal"
    density="compact"
    :class="alertClass"
  >
    <div class="d-flex align-center justify-space-between flex-wrap ga-2">
      <span>
        <template v-if="loading">
          <template v-if="loadTarget">
            Loading scores for <strong>{{ formattedDate }}</strong>…
          </template>
          <template v-else>
            Loading today's scores…
          </template>
          <v-progress-circular
            indeterminate
            size="16"
            width="2"
            class="ml-2"
          ></v-progress-circular>
        </template>
        <template v-else>
          Showing scores for <strong>{{ formattedDate }}</strong>
        </template>
      </span>
      <v-btn
        v-if="showClearButton"
        size="small"
        variant="text"
        class="text-none"
        :disabled="loading"
        @click="$emit('clear')"
      >
        View today
      </v-btn>
    </div>
    <div v-if="error" class="text-caption text-error mt-1">{{ error }}</div>
  </v-alert>
</template>

<script>
import { formatHistoricalDate } from '@/utils/historicalData'

export default {
  name: 'HistoricalDateBanner',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadTarget: {
      type: String,
      default: null
    },
    selectedDate: {
      type: String,
      default: null
    },
    error: {
      type: String,
      default: null
    },
    alertClass: {
      type: String,
      default: 'mb-4'
    }
  },
  emits: ['clear'],
  computed: {
    formattedDate() {
      const date = this.loading ? this.loadTarget : this.selectedDate
      return formatHistoricalDate(date)
    },
    showClearButton() {
      return !this.loading && Boolean(this.selectedDate)
    }
  }
}
</script>
